import { render, staticRenderFns } from "./ExtratoClientesDadosTicketMedio.vue?vue&type=template&id=8d3d4f5c&scoped=true&"
import script from "./ExtratoClientesDadosTicketMedio.vue?vue&type=script&lang=js&"
export * from "./ExtratoClientesDadosTicketMedio.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoClientesDadosTicketMedio.vue?vue&type=style&index=0&id=8d3d4f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3d4f5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
